import React from "react";
import { AccordionSet, Accordion, Checkbox, Button, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekTextField } from "./inputs";
import { PublisherStatusEnum } from "../types/Api";
import { getStatusTranslation } from "../utils/getStatusTranslation";
export var PublisherFilters = function (_a) {
    var filters = _a.filters, onFilterChange = _a.onFilterChange, onStatusChange = _a.onStatusChange, onApplyFilters = _a.onApplyFilters, hasUnappliedChanges = _a.hasUnappliedChanges;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.publisher.filter.name",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.publisher.filter.name", value: filters.name, onChange: function (e) {
                        return onFilterChange("name", e.target.value);
                    }, placeholder: formatMessage({
                        id: "ui-br-agency.publisher.filter.name.placeholder",
                    }), showLabel: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.publisher.filter.label.status",
                }), separator: false }, Object.values(PublisherStatusEnum).map(function (status) { return (React.createElement(Checkbox, { key: status, label: getStatusTranslation(intl, status), checked: filters.statuses.includes(status), onChange: function () { return onStatusChange(status); } })); }))),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", disabled: !hasUnappliedChanges },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.apply" }))));
};
